"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _effects = require("redux-saga/effects");
var _appActions = require("./appActions");
var _taggingEventsUtil = require("../utils/taggingEventsUtil");
var _questionnaireSelectors = require("./questionnaire/questionnaireSelectors");
var _questionnaireActions = require("./questionnaire/questionnaireActions");
var _uiActions = require("./ui/uiActions");
var _recommendationActions = require("./recommendation/recommendationActions");
var _recommendationSelectors = require("./recommendation/recommendationSelectors");
var _shareRecommendationActions = require("./shareRecommendation/shareRecommendationActions");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(watchQuestionnaireEvents),
  _marked2 = /*#__PURE__*/_regeneratorRuntime().mark(watchRecommendationResultEvent),
  _marked3 = /*#__PURE__*/_regeneratorRuntime().mark(getProductTier),
  _marked4 = /*#__PURE__*/_regeneratorRuntime().mark(watchRecommendationUpdateEvents),
  _marked5 = /*#__PURE__*/_regeneratorRuntime().mark(watchStepsEvents),
  _marked6 = /*#__PURE__*/_regeneratorRuntime().mark(watchShareRecommendationEvents),
  _marked7 = /*#__PURE__*/_regeneratorRuntime().mark(watchCheckoutEvents),
  _marked8 = /*#__PURE__*/_regeneratorRuntime().mark(watchTaggingEvents);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * Watch the questionnaire lifecycle events
 */
function watchQuestionnaireEvents(action) {
  var _eventsNames;
  var _yield$select, currentViewQuestion, currentViewQuestionIndex, pageTitle, taggingEventData, eventsNames, currentEvent, taggingEventPayload;
  return _regeneratorRuntime().wrap(function watchQuestionnaireEvents$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.next = 2;
        return (0, _effects.select)(_questionnaireSelectors.selectViewQuestionInfo);
      case 2:
        _yield$select = _context.sent;
        currentViewQuestion = _yield$select.question;
        currentViewQuestionIndex = _yield$select.index;
        pageTitle = currentViewQuestion === null || currentViewQuestion === void 0 ? void 0 : currentViewQuestion.title.toLowerCase().trim().replace('?', '').replace(/ /g, '_');
        taggingEventData = {
          pageName: pageTitle,
          eventLabel: pageTitle,
          stepIndex: currentViewQuestionIndex + 1
        };
        eventsNames = (_eventsNames = {}, _defineProperty(_eventsNames, _uiActions.OPEN_GUIDED_SELLING_MODAL, {
          eventName: 'onToolStart',
          stepIndex: 0,
          eventLabel: 'start',
          pageName: 'start'
        }), _defineProperty(_eventsNames, _questionnaireActions.VIEW_QUESTION, {
          eventName: 'onToolView'
        }), _defineProperty(_eventsNames, _questionnaireActions.GOTO_NEXT_QUESTION, {
          eventName: 'onToolNext'
        }), _defineProperty(_eventsNames, _questionnaireActions.GOTO_PREVIOUS_QUESTION, {
          eventName: 'onToolBack'
        }), _defineProperty(_eventsNames, _questionnaireActions.RESET_QUESTIONNAIRE, {
          eventName: 'onToolRestart'
        }), _defineProperty(_eventsNames, _questionnaireActions.END_QUESTIONNAIRE, {
          eventName: 'onToolEnd'
        }), _eventsNames);
        currentEvent = eventsNames[action.type];
        if (!currentEvent) {
          _context.next = 15;
          break;
        }
        taggingEventData = _objectSpread(_objectSpread({}, taggingEventData), currentEvent);
        taggingEventPayload = (0, _taggingEventsUtil.composeTaggingEventPayload)(taggingEventData);
        if (!taggingEventPayload) {
          _context.next = 15;
          break;
        }
        _context.next = 15;
        return (0, _effects.put)({
          type: _appActions.SEND_TAGS,
          payload: taggingEventPayload
        });
      case 15:
      case "end":
        return _context.stop();
    }
  }, _marked);
}

/**
 * Watch on recommendation set and displayed
 */
function watchRecommendationResultEvent() {
  var taggingEventData, taggingEventPayload;
  return _regeneratorRuntime().wrap(function watchRecommendationResultEvent$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        taggingEventData = {
          pageName: "result:Best Match",
          eventName: 'onToolResult',
          stepIndex: -1
        };
        taggingEventPayload = (0, _taggingEventsUtil.composeTaggingEventPayload)(taggingEventData);
        if (!taggingEventPayload) {
          _context2.next = 5;
          break;
        }
        _context2.next = 5;
        return (0, _effects.put)({
          type: _appActions.SEND_TAGS,
          payload: taggingEventPayload
        });
      case 5:
      case "end":
        return _context2.stop();
    }
  }, _marked2);
}
function getProductTier(productId) {
  var currentProductId, broadbandId, handsetId, planId, bsId, broadbandRecommendation, plansRecommendation, bsRecommendation, handsetsRecommendation, recommendation, currentProduct, tiers;
  return _regeneratorRuntime().wrap(function getProductTier$(_context3) {
    while (1) switch (_context3.prev = _context3.next) {
      case 0:
        currentProductId = productId;
        if (productId) {
          _context3.next = 15;
          break;
        }
        _context3.next = 4;
        return (0, _effects.select)(_recommendationSelectors.selectSelectedBroadbandId);
      case 4:
        broadbandId = _context3.sent;
        _context3.next = 7;
        return (0, _effects.select)(_recommendationSelectors.selectSelectedHandsetId);
      case 7:
        handsetId = _context3.sent;
        _context3.next = 10;
        return (0, _effects.select)(_recommendationSelectors.selectSelectedPlanId);
      case 10:
        planId = _context3.sent;
        _context3.next = 13;
        return (0, _effects.select)(_recommendationSelectors.selectSelectedBroadbandId);
      case 13:
        bsId = _context3.sent;
        currentProductId = handsetId || planId || broadbandId || bsId;
      case 15:
        _context3.next = 17;
        return (0, _effects.select)(_recommendationSelectors.selectRecommendationBroadbands);
      case 17:
        broadbandRecommendation = _context3.sent;
        _context3.next = 20;
        return (0, _effects.select)(_recommendationSelectors.selectRecommendationPlans);
      case 20:
        plansRecommendation = _context3.sent;
        _context3.next = 23;
        return (0, _effects.select)(_recommendationSelectors.selectRecommendationBusinessSolutions);
      case 23:
        bsRecommendation = _context3.sent;
        _context3.next = 26;
        return (0, _effects.select)(_recommendationSelectors.selectRecommendationHandsets);
      case 26:
        handsetsRecommendation = _context3.sent;
        recommendation = [].concat(_toConsumableArray(broadbandRecommendation), _toConsumableArray(plansRecommendation), _toConsumableArray(bsRecommendation), _toConsumableArray(handsetsRecommendation)); // find current selected product
        currentProduct = recommendation.find(function (product) {
          return product.productId === currentProductId;
        });
        if (currentProduct) {
          _context3.next = 31;
          break;
        }
        return _context3.abrupt("return");
      case 31:
        tiers = {
          recommended: 'Best Match',
          alternative: 'Alternative',
          premium: 'Premium'
        };
        return _context3.abrupt("return", tiers[currentProduct.tier]);
      case 33:
      case "end":
        return _context3.stop();
    }
  }, _marked3);
}

/**
 * Watch on recommendation selection update (on tap switch)
 */
function watchRecommendationUpdateEvents(action) {
  var currentProductTier, taggingEventData, taggingEventPayload;
  return _regeneratorRuntime().wrap(function watchRecommendationUpdateEvents$(_context4) {
    while (1) switch (_context4.prev = _context4.next) {
      case 0:
        _context4.next = 2;
        return getProductTier(action.payload.productId);
      case 2:
        currentProductTier = _context4.sent;
        if (currentProductTier) {
          _context4.next = 5;
          break;
        }
        return _context4.abrupt("return");
      case 5:
        taggingEventData = {
          pageName: "result:".concat(currentProductTier),
          eventName: 'onToolResult',
          stepIndex: -1
        };
        taggingEventPayload = (0, _taggingEventsUtil.composeTaggingEventPayload)(taggingEventData);
        if (!taggingEventPayload) {
          _context4.next = 10;
          break;
        }
        _context4.next = 10;
        return (0, _effects.put)({
          type: _appActions.SEND_TAGS,
          payload: taggingEventPayload
        });
      case 10:
      case "end":
        return _context4.stop();
    }
  }, _marked4);
}

/**
 * Watch user interactions with steps
 */
function watchStepsEvents(action) {
  var _actionsEventNames;
  var currentProductTier, actionsEventNames, taggingEventData, taggingEventPayload;
  return _regeneratorRuntime().wrap(function watchStepsEvents$(_context5) {
    while (1) switch (_context5.prev = _context5.next) {
      case 0:
        _context5.next = 2;
        return getProductTier();
      case 2:
        currentProductTier = _context5.sent;
        actionsEventNames = (_actionsEventNames = {}, _defineProperty(_actionsEventNames, _recommendationActions.GO_TO_NEXT_STEP, 'onToolNext'), _defineProperty(_actionsEventNames, _recommendationActions.GO_TO_PREVIOUS_STEP, 'onToolBack'), _actionsEventNames);
        taggingEventData = {
          pageName: "result:".concat(currentProductTier),
          eventName: actionsEventNames[action.type],
          eventLabel: 'result',
          stepIndex: -1
        };
        taggingEventPayload = (0, _taggingEventsUtil.composeTaggingEventPayload)(taggingEventData);
        if (!taggingEventPayload) {
          _context5.next = 9;
          break;
        }
        _context5.next = 9;
        return (0, _effects.put)({
          type: _appActions.SEND_TAGS,
          payload: taggingEventPayload
        });
      case 9:
      case "end":
        return _context5.stop();
    }
  }, _marked5);
}

/**
 * Watch send share recommendation event
 */
function watchShareRecommendationEvents() {
  var currentProductTier, taggingEventData, taggingEventPayload;
  return _regeneratorRuntime().wrap(function watchShareRecommendationEvents$(_context6) {
    while (1) switch (_context6.prev = _context6.next) {
      case 0:
        _context6.next = 2;
        return getProductTier();
      case 2:
        currentProductTier = _context6.sent;
        taggingEventData = {
          pageName: "result:".concat(currentProductTier),
          eventName: "onToolShare",
          eventLabel: 'result',
          stepIndex: -1
        };
        taggingEventPayload = (0, _taggingEventsUtil.composeTaggingEventPayload)(taggingEventData);
        if (!taggingEventPayload) {
          _context6.next = 8;
          break;
        }
        _context6.next = 8;
        return (0, _effects.put)({
          type: _appActions.SEND_TAGS,
          payload: taggingEventPayload
        });
      case 8:
      case "end":
        return _context6.stop();
    }
  }, _marked6);
}

/**
 * Watch checkout event
 */
function watchCheckoutEvents() {
  var currentProductTier, taggingEventData, taggingEventPayload;
  return _regeneratorRuntime().wrap(function watchCheckoutEvents$(_context7) {
    while (1) switch (_context7.prev = _context7.next) {
      case 0:
        _context7.next = 2;
        return getProductTier();
      case 2:
        currentProductTier = _context7.sent;
        taggingEventData = {
          pageName: "result:".concat(currentProductTier),
          eventName: "onToolCheckout",
          eventLabel: 'result',
          stepIndex: -1
        };
        taggingEventPayload = (0, _taggingEventsUtil.composeTaggingEventPayload)(taggingEventData);
        if (!taggingEventPayload) {
          _context7.next = 8;
          break;
        }
        _context7.next = 8;
        return (0, _effects.put)({
          type: _appActions.SEND_TAGS,
          payload: taggingEventPayload
        });
      case 8:
      case "end":
        return _context7.stop();
    }
  }, _marked7);
}
function watchTaggingEvents() {
  return _regeneratorRuntime().wrap(function watchTaggingEvents$(_context8) {
    while (1) switch (_context8.prev = _context8.next) {
      case 0:
        _context8.next = 2;
        return (0, _effects.takeEvery)(_uiActions.OPEN_GUIDED_SELLING_MODAL, watchQuestionnaireEvents);
      case 2:
        _context8.next = 4;
        return (0, _effects.takeEvery)(_questionnaireActions.VIEW_QUESTION, watchQuestionnaireEvents);
      case 4:
        _context8.next = 6;
        return (0, _effects.takeEvery)(_questionnaireActions.GOTO_NEXT_QUESTION, watchQuestionnaireEvents);
      case 6:
        _context8.next = 8;
        return (0, _effects.takeEvery)(_questionnaireActions.GOTO_PREVIOUS_QUESTION, watchQuestionnaireEvents);
      case 8:
        _context8.next = 10;
        return (0, _effects.takeEvery)(_questionnaireActions.RESET_QUESTIONNAIRE, watchQuestionnaireEvents);
      case 10:
        _context8.next = 12;
        return (0, _effects.takeEvery)(_questionnaireActions.END_QUESTIONNAIRE, watchQuestionnaireEvents);
      case 12:
        _context8.next = 14;
        return (0, _effects.takeEvery)(_recommendationActions.SET_RECOMMENDATION, watchRecommendationResultEvent);
      case 14:
        _context8.next = 16;
        return (0, _effects.takeEvery)(_recommendationActions.UPDATE_SELECTED_HANDSET, watchRecommendationUpdateEvents);
      case 16:
        _context8.next = 18;
        return (0, _effects.takeEvery)(_recommendationActions.UPDATE_SELECTED_BROADBAND, watchRecommendationUpdateEvents);
      case 18:
        _context8.next = 20;
        return (0, _effects.takeEvery)(_recommendationActions.UPDATE_SELECTED_BUSINESS_SOLUTION, watchRecommendationUpdateEvents);
      case 20:
        _context8.next = 22;
        return (0, _effects.takeEvery)(_recommendationActions.UPDATE_SELECTED_PLAN, watchRecommendationUpdateEvents);
      case 22:
        _context8.next = 24;
        return (0, _effects.takeEvery)(_recommendationActions.GO_TO_NEXT_STEP, watchStepsEvents);
      case 24:
        _context8.next = 26;
        return (0, _effects.takeEvery)(_recommendationActions.GO_TO_PREVIOUS_STEP, watchStepsEvents);
      case 26:
        _context8.next = 28;
        return (0, _effects.takeEvery)(_shareRecommendationActions.SEND_RECOMMENDATION_SUCCESS, watchShareRecommendationEvents);
      case 28:
        _context8.next = 30;
        return (0, _effects.takeEvery)(_appActions.CHECKOUT_SUCCESS, watchCheckoutEvents);
      case 30:
      case "end":
        return _context8.stop();
    }
  }, _marked8);
}
var _default = [watchTaggingEvents()];
exports.default = _default;